import React from 'react';
import HomeFloorBox from './home-floor-box';
import DiceCards from './dice-card';
import {HomeGameCardItem} from '@/pages/home/home.type';

interface HomeFloorCarProps {
  name: string;
  id: string;
  games: HomeGameCardItem[];
  shown?: boolean;
  categoryPic?: string;
}

const HomeFloorDice = ({
  name,
  games,
  categoryPic,
  id,
  shown = true,
}: HomeFloorCarProps) => {
  return (
    <HomeFloorBox
      gameType="dice"
      id={id}
      shown={shown}
      name={name}
      categoryPic={categoryPic}>
      <div className="flex flex-row overflow-auto gap-2">
        {games.map((item, _i) => (
          <DiceCards key={_i} i={_i} v={item} />
        ))}
      </div>
    </HomeFloorBox>
  );
};

export default HomeFloorDice;
